// AbsenceCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Ketidakhadiran untuk Mata Kuliah";
const DESCRIPTION = "Hitung persentase ketidakhadiran yang diizinkan untuk mata kuliah";
const KEYWORDS =
  "kalkulator ketidakhadiran, persentase ketidakhadiran, ketidakhadiran akademik, hitung ketidakhadiran, hari ketidakhadiran yang diizinkan, jadwal akademik, semester, penilaian akademik, kelulusan akademik, mahasiswa, universitas, sekolah, pendidikan, hitung persentase ketidakhadiran, program hitung persentase ketidakhadiran, hitung ketidakhadiran, hitung jam ketidakhadiran";
const OG_URL = "https://do-calculate.com/calculator/id/absence-calculator/";
function AbsenceCalculator() {
  const [numDays, setNumDays] = useState(1);
  const [hoursPerDay, setHoursPerDay] = useState([""]);
  const [numSemesters, setNumSemesters] = useState(16);
  const [allowedAbsence, setAllowedAbsence] = useState(10);
  const [totalHours, setTotalHours] = useState(0);
  const [allowedAbsenceHours, setAllowedAbsenceHours] = useState(0);
  const [estimatedAbsenceDays, setEstimatedAbsenceDays] = useState(0);
  const [error, setError] = useState("");
  const handleNumDaysChange = (e) => {
    const days = parseInt(e.target.value);
    setNumDays(days);
    setHoursPerDay(Array(days).fill(""));
  };
  const handleHoursPerDayChange = (index, value) => {
    const newHoursPerDay = [...hoursPerDay];
    newHoursPerDay[index] = value;
    setHoursPerDay(newHoursPerDay);
  };
  const handleCalculate = () => {
    try {
      const totalHoursPerWeek = hoursPerDay.reduce(
        (acc, curr) => acc + parseFloat(curr || 0),
        0
      );
      const totalHours = totalHoursPerWeek * numSemesters;
      const allowedAbsenceHours = (totalHours * allowedAbsence) / 100;
      const averageHoursPerDay = totalHoursPerWeek / numDays;
      const estimatedAbsenceDays = allowedAbsenceHours / averageHoursPerDay;
      setTotalHours(totalHours);
      setAllowedAbsenceHours(allowedAbsenceHours);
      setEstimatedAbsenceDays(estimatedAbsenceDays.toFixed(2));
      setError("");
    } catch (error) {
      setError("Terjadi kesalahan saat menghitung. Silakan periksa input.");
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Dapatkan perhitungan akurat tentang persentase ketidakhadiran yang diizinkan dalam studi Anda dengan mudah!
                  Alat cerdas ini dirancang untuk membantu Anda menentukan berapa banyak sesi yang dapat Anda lewatkan tanpa mempengaruhi nilai akhir Anda.
                </p>{" "}
                <p>Cukup masukkan informasi berikut:</p>
                <ul>
                  <li>
                    Jumlah hari kuliah per minggu: baik Anda belajar lima hari atau lebih, kalkulator ini dapat menangani semua jadwal akademik.
                  </li>
                  <li>
                    Jumlah jam kuliah per hari: tentukan durasi setiap sesi kuliah untuk menentukan total jam kuliah mingguan.
                  </li>
                  <li>
                    Jumlah semester: baik Anda dalam satu semester atau lebih, Anda akan mendapatkan hasil akurat yang sesuai dengan situasi Anda.
                  </li>
                  <li>
                    Persentase ketidakhadiran yang diizinkan: tentukan persentase ketidakhadiran yang diizinkan oleh institusi pendidikan Anda untuk mendapatkan perhitungan akurat.
                  </li>
                </ul>
                <p>Mengapa menggunakan kalkulator ini?</p>
                <ul>
                  <li>Perencanaan Lebih Baik: Rencanakan ketidakhadiran Anda dengan sadar berdasarkan perhitungan akurat.</li>
                  <li>Hindari Masalah Akademik: Pastikan persentase ketidakhadiran Anda dalam batas yang diizinkan untuk menghindari dampak negatif pada nilai Anda.</li>
                  <li>Ketenangan Pikiran: Dapatkan jawaban yang jelas dan cepat tentang persentase ketidakhadiran yang diizinkan.</li>
                </ul>
                <hr />
              </div>
              <br />
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="numDays">
                          Jumlah hari mata kuliah per minggu
                        </label>
                      </b>
                      <select
                        id="numDays"
                        className="form-control"
                        value={numDays}
                        onChange={handleNumDaysChange}
                        style={{ width: "75%" }}
                      >
                        <option value={1}>Satu hari</option>
                        <option value={2}>Dua hari</option>
                        <option value={3}>Tiga hari</option>
                      </select>
                    </div>
                    {hoursPerDay.map((_, index) => (
                      <div
                        key={index}
                        className="form-group d-flex align-items-center"
                      >
                        <b>
                          <label className="form-label ms-2">
                            Masukkan jumlah jam untuk hari {index + 1}
                          </label>
                        </b>
                        <input
                          type="number"
                          value={hoursPerDay[index]}
                          onChange={(e) =>
                            handleHoursPerDayChange(index, e.target.value)
                          }
                          placeholder="Masukkan jumlah jam"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                      </div>
                    ))}
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="semesters">
                          Jumlah semester
                        </label>
                      </b>
                      <select
                        id="semesters"
                        className="form-control"
                        value={numSemesters}
                        onChange={(e) =>
                          setNumSemesters(parseInt(e.target.value))
                        }
                        style={{ width: "75%" }}
                      >
                        <option value={16}>Dua semester (16 minggu)</option>
                        <option value={12}>Tiga semester (12 minggu)</option>
                      </select>
                    </div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="absence">
                          Persentase ketidakhadiran yang diizinkan
                        </label>
                      </b>
                      <select
                        id="absence"
                        className="form-control"
                        value={allowedAbsence}
                        onChange={(e) =>
                          setAllowedAbsence(parseInt(e.target.value))
                        }
                        style={{ width: "75%" }}
                      >
                        <option value={10}>10%</option>
                        <option value={15}>15%</option>
                        <option value={20}>20%</option>
                        <option value={25}>25%</option>
                        <option value={30}>30%</option>
                        <option value={35}>35%</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Error: {error}
                    </p>
                  )}
                  {totalHours > 0 &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Hasil:</h4>
                      <p>Total jumlah jam: {totalHours}</p>
                      <p>Jumlah jam yang diizinkan untuk ketidakhadiran: {allowedAbsenceHours.toFixed(2)}</p>
                      <p>
                        Perkiraan jumlah hari yang diizinkan untuk ketidakhadiran:{" "}
                        {estimatedAbsenceDays} hari
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Informasi Tambahan</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Cara Penggunaan</h2>
                  </u>
                  <p>
                    Untuk mendapatkan manfaat maksimal dari kalkulator ini, harap masukkan data dengan akurat.
                  </p>
                  <div className="p-3 mb-2 bg-info">
                    Contoh: Jika mata kuliah diajarkan 3 hari seminggu, masukkan jumlah jam setiap hari.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Tips Menghitung Ketidakhadiran</h2>
                  </u>
                  <p>
                    Perhatikan hari ketidakhadiran yang diizinkan sesuai dengan persentase yang dipilih.
                  </p>
                  <ul>
                    <li>Pastikan akurasi jam yang dimasukkan.</li>
                    <li>Pilih persentase yang sesuai.</li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    Persentase ketidakhadiran menentukan jumlah jam yang diizinkan untuk ketidakhadiran.
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Pertanyaan Umum</h2>
                  </u>
                  <p>Bagaimana cara menghitung ketidakhadiran?</p>
                  <ul>
                    <li>Tentukan jumlah hari dan jumlah jam setiap hari.</li>
                    <li>Pilih jumlah semester.</li>
                    <li>Pilih persentase ketidakhadiran yang diizinkan.</li>
                  </ul>
                  <p>
                    Total jam yang diizinkan untuk ketidakhadiran dihitung berdasarkan input.
                  </p>
                  <b>Contoh</b>
                  <div className="p-3 mb-2 bg-info text-black">
                    Jika mata kuliah diajarkan dua hari seminggu, dengan 3 jam setiap hari, perhitungan dilakukan berdasarkan jumlah minggu dan semester.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default AbsenceCalculator;